import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from '@awaze/design-system.components.button';
import { getDateFNSLocale, } from '@awaze/design-system.utils.react';
import { format } from 'date-fns';
// @todo: Fetch icons from icons-component
import { InfoIcon, SearchIcon } from './icons';
import { DetailSummaryStyled, HintTextStyled, LocationTextStyled, SearchPlaceholderStyled, SearchSummaryWrapStyled, } from './search-summary.styles';
import { formatGuestsString, formatNightsString, formatRangeString, } from './search-summary.utils';
/**
 * A composition to display a summary of the current search criteria, or a hint to add more details if no search criteria are present.
 *
 * Clicking anywhere on the summary triggers the `onClick` prop.
 */
export const SearchSummaryBar = ({ translations, destination, start, nights, range, guests, onClick, isFloating = true, locale = 'en', }) => {
    const { hintLabel, defaultPlaceholder, dateNoLocationPlaceholder, locationNoDatePlaceholder, daysLabel, nightLabel, nightsLabel, guestLabel, guestsLabel, searchIconTitle, } = translations;
    const hasOptionalFields = nights && guests;
    const REGIONAL_DATED = destination && start && hasOptionalFields;
    const NO_REGIONAL_DATED = !destination && start && hasOptionalFields;
    const REGIONAL_NO_DATED = !start && destination;
    const formattedDate = start &&
        format(start, 'd MMM', {
            locale: getDateFNSLocale(locale),
        });
    const nightsText = nights && formatNightsString(nights, nightLabel, nightsLabel);
    const rangeText = range > 0 ? formatRangeString(range, daysLabel) : '';
    const guestsText = guests && formatGuestsString(guests, guestLabel, guestsLabel);
    let display = (_jsxs(_Fragment, { children: [_jsx(HintTextStyled, { children: hintLabel }), _jsx(SearchPlaceholderStyled, { children: defaultPlaceholder })] }));
    if (REGIONAL_DATED) {
        display = (_jsxs(_Fragment, { children: [_jsx(LocationTextStyled, { children: destination }), _jsx(DetailSummaryStyled, { children: `${formattedDate}, ${nightsText}${rangeText && `, ${rangeText}`} • ${guestsText}` })] }));
    }
    if (NO_REGIONAL_DATED) {
        display = (_jsxs(_Fragment, { children: [_jsx(SearchPlaceholderStyled, { children: dateNoLocationPlaceholder }), _jsx(DetailSummaryStyled, { children: `${formattedDate}, ${nightsText}${rangeText && `, ${rangeText}`} • ${guestsText}` })] }));
    }
    if (REGIONAL_NO_DATED) {
        display = (_jsxs(_Fragment, { children: [_jsx(LocationTextStyled, { children: destination }), _jsxs(DetailSummaryStyled, { children: [_jsx(InfoIcon, {}), locationNoDatePlaceholder] })] }));
    }
    return (_jsxs(SearchSummaryWrapStyled, { type: "button", onClick: onClick, "data-testid": "search-summary-button", isFloating: isFloating, children: [_jsx("div", { children: display }), _jsx(IconButton, { as: "div", colourScheme: "brand-primary", icon: _jsx(SearchIcon, {}), title: searchIconTitle, size: "small" })] }));
};
//# sourceMappingURL=search-summary-bar.js.map